import { Translations } from '../../../shared/i18n/Translations'
import { UI_dialogOk } from '../UI/UI.Dialog'
import { User_vibrationOn } from '../User/User.get'

/** Can be called before device ready */
export function Plat_isCordova() {
    return window.cordova != null
}

/** Must be called after device ready event */
export function Plat_isIOS() {
    return window.device && device.platform.toUpperCase() === 'IOS'
}

export function Plat_isAndroid() {
    return window.device && device.platform.toUpperCase() === 'ANDROID'
}

export function Plat_vibrate(duration: number) {
    if (User_vibrationOn()) {
        navigator.vibrate(duration)
    }
}

export function Plat_getDeviceInfo() {
    return window.device
}

export async function Plat_viewFile(url: string, _name: string, _mimeType: string) {
    if (Plat_isCordova() === false) {
        window.open(url)
        return
    }

    const ref = window.cordova.InAppBrowser.open(
        url,
        '_blank', // make this _system to open in the default system browser
        [
            'location=no',
            'toolbar=yes',
            'toolbarposition=top',
            'disallowoverscroll=yes',
            'enableViewportScale=yes',
            'hidden=no',
        ].join(',')
    )

    // Wait for the in-app browser to close
    await new Promise<void>((resolve) => {
        const onClose = () => {
            ref.removeEventListener('exit', onClose)
            resolve()
        }
        ref.addEventListener('exit', onClose)
    })
}

export function Plat_noAppInstalledToOpenFileTypeError() {
    return UI_dialogOk(Translations.t('app:common.warning'), Translations.t('app:platform.noApp.cannotOpen'))
}

export function Plat_exit() {
    if (Plat_isCordova()) {
        window.navigator.app.exitApp()
    }
    window.close()
}
